import { ApiProperty } from "@nestjs/swagger";

export class CreateJobworkDto {
    @ApiProperty()
    jobworkId: number;

    @ApiProperty()
    unit: number;

    @ApiProperty()
    subJobId: number;

    @ApiProperty()
    division: string;

    @ApiProperty()
    buyer: string;

    @ApiProperty()
    operationType: string;

    @ApiProperty()
    styleNo: string;

    @ApiProperty()
    itemNo: string;

    @ApiProperty()
    addonOrderQty: number;

    @ApiProperty()
    totalOrderQty: number;

    @ApiProperty()
    addOnQtyDate: Date;

    @ApiProperty()
    noOfOperations: number;

    @ApiProperty()
    ratePerGarment: number;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;
}
